module.exports = __webpack_public_path__ + "static/img/upload-icon-white.1f47e5af.svg";